<template>
 <b-card>
        <div slot="header">
            <b-row>
                <b-col>
                    <div class="text-center">
                        <b-col>
                            <h3 class="display-">Nota de Débito Electrónica</h3>
                        </b-col>
                    </div>           
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                    <b-row align-v="center">
                        <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4" class="text-right">
                            <label>Tipo:</label>
                        </b-col>
                        <b-col cols="8" sm="8"	md="8"	lg="8"	xl="8">
                                <select class="custom-select mr-sm-2" v-model="tiponotadebito" :disabled="disabledTipoNC">
                                    <option :value="tipo.codigo" v-for="tipo in tiposNotaDebito" v-bind:key="tipo.codigo">
                                    {{ tipo.nombre }}
                                    </option>
                                </select>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                    <b-row class="text-center">
                        <b-col cols="4"	sm="4"	md="4"	lg="4"	xl="12"></b-col>
                        <b-col cols="8"	sm="8"	md="8"	lg="8"	xl="12">
                            <datepicker v-model="femision" :format="customFormatter" :language="es" :bootstrap-styling="true" :disabledDates="diasnopermitidos" :placeholder="currentdate"></datepicker>
                        </b-col>                           
                    </b-row>
                </b-col>
                <!-- Nueva nota de credito (Agregar items) -->
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="5">
                    <b-row align-v="center"> 
                        <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4"></b-col>
                        <b-col v-if="switchitems" cols="12" sm="6"	md="4"	lg="4"	xl="4">
                            <b-row align-v="center">
                                <b-col cols="4" class="text-right">
                                    <label>Moneda</label>
                                </b-col>
                                <b-col cols="8">
                                    <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodemoneda" :disabled="monedaDisabled">
                                    <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                                        {{ moneda.descripcion }}
                                    </option>
                                    </select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col v-else cols="12" sm="6"	md="0"	lg="0"	xl="2"></b-col>
                        <b-col cols="12" sm="6"	md="8"	lg="10"	xl="3">
                            <b-button id="tooltipButton-1" size="sm" variant="outline-success" class="agregaritemsPersonalizado">
                                <b-input-group>
                                    <b-row>
                                        <b-col cols="6" sm="6"	md="6"	lg="6"	xl="5">
                                            <label class="agregaritemsnew"><i class="fa fa-plus"></i> Items</label>
                                        </b-col>
                                        <b-col cols="4" sm="4"	md="4"	lg="6"	xl="4">
                                            <c-switch class="mx-1 cargaritemsPersonalizado" color="primary" v-model="switchitems" label outline="alt" variant="pill" v-bind="labelTxt" />
                                            <b-tooltip :show.sync="show" target="tooltipButton-1" placement="top">
                                                <strong>ND a Facturas fisicas o emitidas en 2.0</strong>
                                            </b-tooltip>
                                        </b-col>
                                    </b-row>
                                </b-input-group>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                    <b-row>
                        <template>
                            <b-col> 
                                <b-input-group>
                                    <template v-if="seriesCargadas">
                                        <b-button size="md" variant="secondary" outline-success>
                                            Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                                        </b-button>
                                    </template>
                                    <template v-else>
                                        <select class="form-control input-placedark input-dark" v-model="indexSerie">
                                            <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                                        </select>
                                    </template>
                                    <!-- <button class="btn btn-warning btn-sm sinresultados2" @click="enableSeries"><i class="fa fa-exchange"></i></button> -->
                                </b-input-group>
                            </b-col>
                        </template>                             
                    </b-row>                        
                </b-col>
            </b-row>
        </div>
        <b-row>
            <b-col cols="12">
                <template v-if="generalesNC">
                    <b-alert variant="secondary" show>
                        <b-row>
                                <b-col cols="4">
                                    <b-row v-if="!switchitems">
                                        <b-col cols="6">
                                            <b-form-group
                                                    label-for="input_serieAfectada"
                                                    :invalid-feedback="invalidFeedbackSerieAfectada"
                                                    :valid-feedback="validFeedbackSerieAfectada"
                                                    :state="stateSerieAfectada">
                                                    <b-input-group size="md" prepend="F">
                                                        <b-form-input :value="serieAfectada" @input="serieAfectada = $event.toUpperCase()" v-model="serieAfectada" maxlength="3" class="form-control input-requerido input-dark" type="text" id="input_serieAfectada" :state="state" placeholder="Serie Afectada(*)"></b-form-input>
                                                    </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="6">
                                            <input v-model="numeroAfectado" type="number" class="form-control input-requerido input-dark" required placeholder="Num. Afectado (*)">
                                        </b-col>
                                    </b-row>
                                    <b-row v-else>
                                        <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                                            <input v-model="serieAfectada" maxlength="4" type="text" class="form-control  input-requerido input-dark" placeholder="Serie (*)">
                                        </b-col>
                                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                                            <input v-model="numeroAfectado" minlength="1" type="text" class="form-control input-requerido input-dark" placeholder="Numero (*)">
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col cols="8">
                                    <b-row>
                                        <b-col cols="1">
                                            <b-row align-h="center">
                                                <b-btn v-b-modal.modal1 v-b-tooltip.hover title="Vista Previa" @click="viewPdf()" disabled><i class="fa fa-tv"></i></b-btn>
                                                <b-modal id="modal1" size="lg" title="Vista Previa" cancel-title="Cerrar">
                                                    <template v-if="cargandopdf2"><div class="text-center"><h3><i class="fa fa-spin fa-spinner"></i></h3> Cargando vista previa</div></template>
                                                    <template v-else>
                                                        <template v-if="pdfobject !==''">
                                                        <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                                                        </template>
                                                    </template>
                                                </b-modal>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="11">
                                            <input v-model="descripcionND" type="text" class="form-control input-requerido input-dark" placeholder="Motivo para la Emision de la Nota de Débito (*)">
                                            <small v-if="checkdescripcionND" class="form-text text-muted"><span class="text-danger">{{ responsedescripcionND }}</span></small>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        <br>
                    </b-alert>
                </template>
            </b-col>
        </b-row>
        <template v-if="!switchitems">
            <!-- Caso 1: Interes por Mora -->
            <template v-if="tiponotadebito == '01'">
                <b-row align-v="center">
                <b-col cols="12" sm="4"	md="3"	lg="2"	xl="1"></b-col>    
                <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                  <input v-if="!vunitario" v-model="precioVentaUnitario" class="form-control input-requerido input-dark" placeholder="Monto (IGV)" @keyup.enter="enter()" required/>
                  <b-form-input v-else v-model="precioVentaUnitario" class="form-control" placeholder="Precio Unitario (con IGV)" required disabled/>
                </b-col>
                <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                  <input v-if="vunitario" @keyup.enter="enter()" type="text" min="0.0" step="0.01" v-model.number="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor (Sin IGV)" required/>
                  <b-form-input v-else type="number" min="0.0" step="0.01" v-model="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor (Sin IGV)" required disabled/>
                </b-col>
                <b-col cols="12" sm="6"	md="3"	lg="2"	xl="2">
                  <b-form-input v-if="tipoOperacion == '0200'" disabled value="Exportación"></b-form-input>
                  <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacionIgv">
                    <option :value="afec.id" v-for="afec in listaafectacion" v-bind:key="afec.id">
                      {{ afec.descripcion }}
                    </option>
                  </select>
                </b-col>
                <b-col v-if="!ventaGratuita" cols="12" sm="6"	md="3"	lg="3"	xl="2">
                  <b-form-input disabled value="Operación Onerosa"></b-form-input>
                </b-col>
                <b-col v-else cols="12" sm="6"	md="3"	lg="3"	xl="2">
                  <b-form-input v-if="tipoOperacion == '0200'" disabled value="Bienes"></b-form-input>
                  <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacion">
                    <option :value="espec" v-for="espec in Especificacion" v-bind:key="espec.id">
                      {{ espec.descripcion }}
                    </option>
                  </select>
                </b-col>
                </b-row>
                <br>
                <div class="text-center">
                    <template v-if="!ValidateCaso1()">
                        <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Emitir</button>
                    </template>
                    <template v-else>
                        <button v-if="!cargandoemisionCaso1" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Emitir</button>
                        <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Emitiendo...</button>
                    </template>
                </div>
            </template>
            <!-- Caso 2: Aumento en el  valor -->
            <template v-else-if="tiponotadebito == '02'">
                <template v-if="descuentoItemSiguiente">
                    <b-row>
                        <b-col cols="6">
                            <b-card border-variant="light"
                                class="text-center">
                                <template slot="header">
                                    <b-row align-v="center">
                                        <b-col cols="4"></b-col>
                                        <b-col cols="4">
                                            <h6>Items de la Factura</h6>
                                        </b-col>
                                        <b-col cols="4">
                                        </b-col>
                                    </b-row>
                                </template>
                                <b-row>
                                    <b-col cols="12">
                                        <template v-if="tiponotadebito == '02'">
                                            <table class="table table-boreder">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%">Cantidad</th>
                                                        <th style="width: 40%">Descripcion</th>
                                                        <th style="width: 15%">V. Unitario</th>
                                                        <th style="width: 15%">Aumento incl. Igv</th>
                                                        <th style="width: 15%">V. Venta</th>
                                                        <th style="width: 10%">Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in listaNotaDebito" :key="index">
                                                        <td>{{ item.cantidad }}</td>
                                                        <td>{{ item.descripcion }}</td>
                                                        <td>{{ item.valorUnitario }}</td>
                                                        <td><b-input class="descuento text-center" v-model="item.aumento"></b-input></td>
                                                        <td>{{ item.valorVenta }}</td>
                                                        <td>
                                                            <button class="btn btn-sm btn-group btn-outline-info" @click.prevent="setrowCaso2(item, index)"><i class="fa fa-plus"></i></button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                        <b-col cols="6">
                            <b-card border-variant="light"
                                header="Items Afectados"
                                class="text-center">
                                <b-row>
                                    <b-col cols="12">
                                        <table class="table table-boreder">
                                            <thead>
                                                <tr>
                                                    <th>Cantidad</th>
                                                    <th>Descripcion</th>
                                                    <th>Valor Unitario</th>
                                                    <th>Valor Venta</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in listaNotaDebitoAfectada" :key="`item-${index}`">
                                                    <td>{{ item.cantidad }}</td>
                                                    <td>{{ item.descripcion }}</td>
                                                    <td>{{ item.valorUnitario }}</td>
                                                    <td>{{ item.valorVenta }}</td>
                                                    <td>
                                                        <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItem(item, index)"><i class="fa fa-trash danger"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-col>
                                </b-row>
                                <div class="row">
                                    <div class="col-md-6 text-right">
                                        <div><strong>Total IGV:</strong></div>
                                        <div><strong>Total Venta Gravada:</strong></div>
                                        <div><strong>Total Venta Exonerada:</strong></div>
                                        <div><strong>Total Venta Inafecta:</strong></div>
                                        <div><strong>Total venta Exportación:</strong></div>
                                        <div><strong>Total Venta:</strong></div>
                                    </div>
                                    <div class="col-md-6">
                                        <div>
                                            S/. {{ accumulateIgv() }}
                                        </div>
                                    <div>
                                        S/. {{ accumulateRecordedSale() }}
                                    </div>
                                    <div>
                                        S/. {{ accumulateExoneratedSale() }}
                                    </div>
                                    <div>
                                        S/. {{ accumulateUnaffectedSale() }}
                                    </div>
                                     <div>
                                        S/. {{ accumulateExportacionVista() }}
                                    </div>  
                                    <div>
                                        S/. {{ accumulateTotalSale() }}
                                    </div>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                </template>
                <template>
                    <b-row>
                        <b-col cols="5"></b-col>
                        <b-col cols="4">
                            <template v-if="validateDebitNote()">
                                    <!-- Paso previo a emitir -->
                                    <template v-if="listaNotaDebitoAfectada.length == 0">
                                        <template v-if="tiponotadebito == '02'">
                                            <button v-if="!cargandoemisionCaso2" class="btn btn-primary" @click="searchInvoice()"><i class="fa fa-location-arrow"></i> Siguiente</button>
                                            <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Cargando...</button>
                                        </template>
                                    </template>
                                    <!-- Paso para emitir -->
                                    <template v-if="listaNotaDebitoAfectada.length > 0">
                                        <template v-if="tiponotadebito == '02'">
                                            <template v-if="!caso5Emitir">
                                                <button class="btn btn-secondary" disabled><i class="fa fa-location-arrow"></i> Emitir</button>
                                            </template>
                                            <template v-else>
                                                <button v-if="!emitiendo" class="btn btn-primary" @click="sendNoteDebit()"><i class="fa fa-location-arrow"></i> Emitir</button>
                                                <button v-else class="btn btn-secondary" disabled><i class="fa fa-spin fa-spinner"></i> Emitiendo...</button>
                                            </template>
                                        </template>
                                    </template>
                            </template>
                            <template v-else>
                                <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Siguiente</button>
                            </template>
                        </b-col>
                    </b-row>
                </template>
            </template>
        </template>
        <template v-else>
            <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                    <b-form-select v-model="selectedDoc" :options="optionsDoc"></b-form-select>
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                    <template v-if="selectedDoc == 0">
                        <b-form-input class="input-placedark input-dark" placeholder="RUC" maxlength="11" v-model="receptor.numero" @change="getReceivers()"></b-form-input>
                        <template v-if="cargandoreceptorND">
                            <b-list-group class="searcher-field">
                            <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                            </b-list-group>
                        </template>
                        <b-list-group v-if="listarec" class="searcher-field">
                            <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                            <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                            <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                                {{item.idReceptor + ' - ' + item.razonSocial}}
                            </b-list-group-item>
                            </template>
                        </b-list-group>
                    </template>
                    <template v-else>
                        <b-form-input class="input-placedark input-dark" placeholder="Otros" maxlength="15" v-model="receptor.numero"></b-form-input>
                    </template>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                        <template v-if="selectedDoc == 0">
                            <b-form-input size="md" type="text" @input="pitcherReceiver(2)" v-model="receptor.razonSocial" :value="receptor.razonSocial" placeholder="Razón Social" class="input-placedark input-dark">
                            </b-form-input>
                        </template>
                        <template v-else>
                            <b-form-input class="input-placedark input-dark" type="text" placeholder="Razón Social" v-model="receptor.razonSocial"></b-form-input>
                        </template>
                    </b-col>
                    <b-col cols="12" sm="12" md="4"	lg="6"	xl="5">
                    <template v-if="selectedDoc == 0">
                            <b-input-group>
                            <b-form-input class="input-placedark input-dark" size="md" type="text" readonly="" placeholder="Dirección " v-model="receptor.direccion"></b-form-input>
                            <b-input-group-text slot="append">
                                <button class="btn btn-warning btn-sm sinresultados" @click="changeDirection()"><i class="fa fa-list"></i></button>
                            </b-input-group-text>
                        </b-input-group>
                        <template v-if="verDirecciones">
                            <template v-for="(item, index) in direcciones" class="buscarRuc">
                            <b-list-group-item :key="index" @click="setDirection(item)" class="searcher-result">
                            {{item.direccion}}
                            </b-list-group-item>
                            </template>
                        </template> 
                    </template>
                    <template v-else>
                        <b-form-input class="input-placedark input-dark" type="text" placeholder="Dirección" v-model="receptor.direccion"></b-form-input>
                    </template>     
                </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="12" sm="3"	md="3"	lg="3"	xl="1">
                <input @keyup.enter="enter()" :min="0.0" :step="0.01" v-model="cantidad" class="form-control input-dark" placeholder="Cantidad (*)" required/>
                <small v-if="checkcantidad" class="form-text text-muted"><span class="text-danger">{{ responsecheckcantidad }}</span></small>
                </b-col>
                <b-col cols="12" sm="3"	md="3"	lg="3"	xl="2">
                <select class="custom-select mr-sm-2 input-placedark input-dark" id="inlineFormCustomSelect" v-model="unidadMedidaCantidad">
                    <option :value="unidad.codigo" v-for="unidad in unidades" v-bind:key="unidad.id">
                    {{ unidad.descripcion }}
                    </option>
                </select>
                </b-col>
                <b-col cols="12" sm="3"	md="3"	lg="3"	xl="1">
                <b-input-group>
                    <b-form-input class="form-control input-placedark input-dark" placeholder="C. Prod." maxlength="30" v-model="codigoProducto" @change="getReceiversProductCode"></b-form-input>
                </b-input-group>
                <template v-if="cargandoCodBarras">
                    <b-list-group class="searcher-field">
                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                    </b-list-group>
                </template>
                <b-list-group v-if="listaProductCode" class="searcher-field">
                    <b-list-group-item v-if="noProductCode">No hay Receptores con ese número</b-list-group-item>
                    <template v-for="(item, index) in listaProductCode">
                    <b-list-group-item :key="index" @click="setReceiverProductCode(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion}}</b-list-group-item>
                    </template>
                </b-list-group>
                </b-col>
                <b-col cols="12" sm="3"	md="3"	lg="3"	xl="1">
                <b-input-group>
                    <b-form-input v-if="tipoOperacion != '0200'" :placeholder="placeholdercodigo" class="form-control input-placedark input-dark" maxlength="8" v-model="codigoSunatBarras" @change="getReceiversBarCodeSunat"></b-form-input>
                    <b-form-input v-else :placeholder="placeholdercodigo" class="form-control input-requerido input-dark" maxlength="8" v-model="codigoSunatBarras" @change="getReceiversBarCodeSunat"></b-form-input>
                </b-input-group>
                <template v-if="cargandoBarrasSunat">
                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                </template>
                <b-list-group v-if="listaBarCodeSunat" class="searcher-field">
                    <template v-for="(item, index) in listaBarCodeSunat">
                    <b-list-group-item :key="index" @click="setReceiverBarCodeSunat(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion}}</b-list-group-item>
                    </template>
                </b-list-group>
                </b-col>

                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="7">
                <b-input-group>
                    <b-form-input placeholder="Descripcion (*)" maxlength="500" v-model="descripcion" @change="getReceiversDescription" class="form-control input-requerido input-dark" type="text"></b-form-input>
                </b-input-group>
                <template v-if="cargandoDescription">
                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                </template>
                <b-list-group v-if="listades" class="searcher-field">
                    <b-list-group-item v-if="nodescription">No se encontraron productos</b-list-group-item>
                    <template v-for="(item, index) in listaDescription">
                    <b-list-group-item :key="index" @click="setReceiverDescription(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion + ' --- Precio: ' + item.precioUnitario}}</b-list-group-item>
                    </template>
                </b-list-group>
                </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="9">
                <b-row>
                    <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                    <input v-if="!vunitario" v-model="precioVentaUnitario" class="form-control input-requerido input-dark" placeholder="Precio Unitario (con IGV)" @keyup.enter="enter()" required/>
                    <b-form-input v-else v-model="precioVentaUnitario" class="form-control" placeholder="Precio Unitario (con IGV)" required disabled/>
                    <small v-if="checkprecioventaunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckprecioventaunitario }}</span></small>
                    </b-col>
                    <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2">
                    <input v-if="vunitario" @keyup.enter="enter()" type="text" min="0.0" step="0.01" v-model.number="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor Unitario (Sin IGV)" required/>
                    <b-form-input v-else type="number" min="0.0" step="0.01" v-model="valorUnitario" class="form-control input-placedark input-dark" placeholder="Valor Unitario (Sin IGV)" required disabled/>
                    <small v-if="checkvalorunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckvalorunitario }}</span></small>
                    </b-col>
                    <b-col cols="12" sm="4"	md="3"	lg="3"	xl="3">
                    <b-row>
                        <b-col cols="12" sm="4"	md="4"	lg="4"	xl="4" class="botondescuento">
                        <b-form-checkbox v-model="descuento">Dscto</b-form-checkbox>
                        </b-col>
                        <b-col cols="12" sm="8"	md="8"	lg="8"	xl="8" v-if="!descuento">
                        <b-row>
                            <b-col cols="12" class="checkdescuentoitem">
                            <b-input-group size="xs" prepend="S/.">
                                <input @keyup.enter="enter()" v-model="descuentoItemMonto" class="form-control input-requerido input-dark"/>
                            </b-input-group>
                            </b-col>
                        </b-row>
                        </b-col>
                        <b-col cols="12" sm="8"	md="8"	lg="8"	xl="8" v-else>
                        <b-row>
                            <b-col cols="12" class="checkdescuentoitem">
                            <b-input-group size="xs" append="%">
                                <input @keyup.enter="enter()" v-model="descuentoItemPorcentaje" class="form-control input-requerido input-dark"/>
                            </b-input-group>
                            </b-col>
                        </b-row>
                        </b-col>
                    </b-row>
                    </b-col>
                    <b-col cols="12" sm="6"	md="3"	lg="2"	xl="2">
                    <b-form-input v-if="tipoOperacion == '0200'" disabled value="Exportación"></b-form-input>
                    <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacionIgv">
                        <option :value="afec.id" v-for="afec in listaafectacion" v-bind:key="afec.id">
                        {{ afec.descripcion }}
                        </option>
                    </select>
                    </b-col>
                    <b-col v-if="!ventaGratuita" cols="12" sm="6"	md="3"	lg="3"	xl="3">
                    <b-form-input disabled value="Operación Onerosa"></b-form-input>
                    </b-col>
                    <b-col v-else cols="12" sm="6"	md="3"	lg="3"	xl="3">
                    <b-form-input v-if="tipoOperacion == '0200'" disabled value="Bienes"></b-form-input>
                    <select v-else class="custom-select mr-sm-2 input-placedark input-dark" v-model="especificacion">
                        <option :value="espec" v-for="espec in Especificacion" v-bind:key="espec.id">
                        {{ espec.descripcion }}
                        </option>
                    </select>
                    </b-col>
                </b-row>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="3">
                    <b-card class="adicionalesOperacionItem">
                        <span class="titulo-opitem"><strong> Operaciones Adicionales </strong></span>
                        <br>
                        <b-form-checkbox v-model="vunitario">
                        Usar valor unitario
                        </b-form-checkbox>
                        <b-form-checkbox v-model="servicio">
                        Servicio
                        </b-form-checkbox>
                        <b-form-checkbox v-model="vbarras">
                        C. Barras
                        </b-form-checkbox>
                        <b-form-checkbox v-model="ventaGratuita">
                        Venta Gratuita
                        </b-form-checkbox>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" class="text-center buttonagregar">
                    <template v-if="!setUpdateItem">
                    <button class="btn btn-primary btnagregarstyle" v-if="validateFields()" @click="addItem()"><i class="fa fa-plus"></i> Agregar</button>
                    <button class="btn btn-secondary btnagregarstyle" disabled v-else><i class="fa fa-plus"></i> Agregar</button>
                    </template>
                    <template v-else>
                    <button class="btn btn-warning" @click="addItem()"><i class="fa fa-plus"></i> Actualizar</button>
                    </template>
                </b-col>
            </b-row>
            <br>
            <b-table 
                responsive
                :small="small"
                :items="items"
                :fields="items_fields"
                :outlined="outlined"
                >
                <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                <template slot="acciones" slot-scope="row">
                    <b-row>
                        <button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click.prevent="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></button>
                        <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItemCasoAddItems(row.index)"><i class="fa fa-trash danger"></i></button>
                    </b-row>
                </template>
            </b-table>
            <hr>
            <b-row>
            <b-col cols="12" sm="12"	md="6"	lg="7"	xl="8">
                <div>
                    <b-btn block v-b-toggle.extras class="m-1 colorestelemovil">Extras</b-btn>
                    <b-collapse id="extras">
                        <b-card>
                            <b-row>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                                <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                                    <option :value="fpago.codigo" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                    {{ fpago.nombre }}
                                    </option>
                                </select>
                                </b-col>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                                    <b-form-group
                                    label-for="input_seriedeguia"
                                    :invalid-feedback="invalidFeedbackOrdenCompra"
                                    :valid-feedback="validFeedbackOrdenCompra"
                                    :state="stateOrdenCompra">
                                    <b-input-group size="md">
                                        <b-form-input :value="ordenCompra"
                                        required
                                        @input="ordenCompra = $event.toUpperCase()"
                                        v-model="ordenCompra"
                                        maxlength="20"
                                        class="form-control input-placedark input-dark"
                                        type="text"
                                        id="input_ordendecompra"
                                        :state="stateOrdenCompra"
                                        placeholder="Orden de Compra">
                                    </b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                                <datepicker class="input-placedark input-dark" v-model="fvencimiento" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha de Vencimiento"></datepicker>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-collapse>
                </div>
                <div>
                    <b-btn block v-b-toggle.relacionadas class="m-1 colorestelemovil">Guias Relacionadas</b-btn>
                    <b-collapse id="relacionadas">
                        <b-card>
                        <b-row>
                            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                            <b-form-group
                            label-for="input_seriedeguia"
                            :invalid-feedback="invalidFeedbackSerieGuia"
                            :valid-feedback="validFeedbackSerieGuia"
                            :state="stateSerieGuia">
                            <b-input-group size="md">
                                <b-form-input :value="seriedeguia"
                                required @input="seriedeguia = $event.toUpperCase()"
                                v-model="seriedeguia"
                                minlength="4"
                                maxlength="4"
                                class="form-control input-placedark input-dark"
                                type="text"
                                id="input_seriedeguia"
                                :state="stateSerieGuia"
                                placeholder="Serie">
                            </b-form-input>
                            </b-input-group>
                        </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                        <b-form-input v-model="numerodeguia" class="form-control input-placedark input-dark" placeholder="Numero" required/>
                        </b-col>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodeguia" :disabled="tipoguialock">
                            <option :value="tipo.codigo" v-for="tipo in tiposGuia" v-bind:key="tipo.codigo">
                            {{ tipo.nombre }}
                            </option>
                        </select>
                        </b-col>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                        <button v-if="validateFieldsGuia()" class="btn btn-primary" @click="addGuia"><i class="fa fa-plus"></i> Agregar</button>
                        <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-table striped hover :items="items_guias" :fields="fields_guias">
                        <template striped hover slot="acciones" slot-scope="row">
                            <b-button-group>
                            <b-button title="Eliminar Guia" @click="deleteGuia(row.item)"><i class="fa fa-trash"></i></b-button>
                            </b-button-group>
                        </template>
                        </b-table>
                    </b-row>
                    </b-card>
                    </b-collapse>
                </div>
                <div>
                    <b-btn block v-b-toggle.adicionales class="m-1 colorestelemovil">Datos Adicionales</b-btn>
                    <b-collapse id="adicionales">
                        <b-card>
                        <b-row>
                            <b-col cols="12" sm="12"	md="12"	lg="4"	xl="5">
                            <input type="text" placeholder="Nombre del Adicional" class="form-control input-placedark input-dark" v-model="key">
                            </b-col>
                            <b-col cols="12" sm="12"	md="12"	lg="4"	xl="5">
                            <input type="text" placeholder="Valor del Adicional" class="form-control input-placedark input-dark" v-model="value">
                            </b-col>
                            <b-col cols="12" sm="12"	md="12"	lg="4"	xl="2">
                            <button v-if="validateFieldsAdicionales()" class="btn btn-primary" @click="addAdicional"><i class="fa fa-plus"></i> Agregar</button>
                            <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-table striped hover :items="items_adicionales" :fields="fields_adicionales">
                            <template striped hover slot="acciones" slot-scope="row">
                                <b-button-group>
                                <b-button title="Eliminar Adicional" @click="deleteAdicional(row.item)"><i class="fa fa-trash"></i></b-button>
                                </b-button-group>
                            </template>
                            </b-table>
                        </b-row>
                        </b-card>
                    </b-collapse>
                </div>
            </b-col>
            <b-col cols="12" sm="12"	md="6"	lg="5"	xl="4">
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                    <div class="text-center">
                        <strong>TOTALES</strong>
                    </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                    <strong>Otros Cargos:</strong>
                    </b-col>
                    <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                    {{ moneda.simbolo }}
                    </b-col>
                    <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12" class="checkdescuentoglobal"><b-input v-model="otrosCargos" disabled></b-input></b-col>
                    </b-row>
                    </b-col>
                </b-row>
                <hr>
                <b-row>
                    <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                        <div><strong>IGV:</strong></div>
                        <div><strong>Venta Gravada:</strong></div>
                        <div><strong>Venta Exonerada:</strong></div>
                        <div><strong>Venta Inafecta:</strong></div>
                        <div><strong>Venta Gratuita:</strong></div>
                        <div><strong>Venta Exportación:</strong></div>
                        <div><strong>Descuentos:</strong></div>
                        <div><strong>Cargos:</strong></div>
                        <div><strong>Venta:</strong></div>
                        <b-row>
                            <b-col cols="12">
                            <template v-if="tipoOperacion == '1001'">
                                <hr>
                                <select class="form-control input-placedark input-dark" v-model="detraccion">
                                <option v-for="detraccion in listaDeDetracciones" :value="detraccion" :key="detraccion.codigo">{{ detraccion.descripcion }}</option>
                                </select>
                                <br>
                            </template>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                        <div>
                            {{ moneda.simbolo }}
                        </div>
                    </b-col>
                    <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                        <div class="alineacionTotales">
                            {{ accumulateIgvAdd() }}
                        </div>
                        <div v-if="descuentoGlobalMonto != '' || descuentoGlobalPorcentaje != ''" class="alineacionTotales">
                            {{ totalVentaGravada }}
                        </div>
                        <div v-else class="alineacionTotales">
                            {{ accumulateRecordedSaleAdd() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateExoneratedSaleAdd() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateUnaffectedSaleAdd() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateFreeSaleAdd() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateExportSaleAdd() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateDescuentoAdd() }}
                        </div>
                        <div class="alineacionTotales">
                            {{ otrosCargos }}
                        </div>
                        <div class="alineacionTotales">
                            {{ accumulateTotalSaleAdd() }}
                        </div>
                        <template v-if="tipoOperacion == '1001'">
                            <hr>
                            <b-row>
                            <b-col cols="4">{{ detraccion.porcentajeDetraccion }}</b-col>
                            </b-row>
                            <b-row>
                            <b-col cols="8">{{ moneda.simbolo }} {{ montoDetraccionCalc() }}</b-col>
                            </b-row>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                    <template v-if="tipoOperacion == '1001'">
                        <b-alert show variant="info">
                        <b-row>
                            <b-col cols="6">Cuenta de Detracciones: </b-col>
                            <b-col cols="6">
                            <template v-if="cuentaDetracionAdmin != ''">
                                <b-col cols="12">
                                <template v-if="cuentaDetracionAdmin != ''">
                                    {{ cuentaDetracionAdmin }}
                                </template>
                                <template v-else>
                                    No existe cuenta de detracción, registrelo en Administrador/Perfil
                                </template>
                                </b-col>
                            </template>
                            <template v-else>
                                Cargando <i class="fa fa-spin fa-spinner"></i>
                            </template>
                            </b-col>
                        </b-row>
                        </b-alert>
                    </template>
                    </b-col>
                </b-row>
                <br>
                <div class="row">
                    <div class="col-md-6"></div>
                    <div class="col-md-4">
                    <template v-if="validateInvoice()">
                        <button v-if="!cargandoemision" class="btn btn-primary" @click.prevent="sendNCAddItems"><i class="fa fa-location-arrow"></i> Emitir</button>
                        <button v-else class="btn btn-seconday"><i class="fa fa-spin fa-spinner"></i> Emitir</button>
                    </template>
                    <template v-else>
                        <button class="btn btn-secondary" disabled><i class="fa fa-send"></i> Emitir</button>
                    </template>
                    </div>
                </div>
                </b-col>
            </b-row>
        </template>
        <vue-snotify></vue-snotify>
 </b-card>
</template>

<script>
const config = {
       headers: {
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Methods': 'POST',
            'Access-Control-Allow-Headers':'*',
            'cache-control': 'no-cache'
          }
}
import { tiposNotaDebitoF } from '@/shared/utils'
import { Switch as cSwitch } from '@coreui/vue'
import axios from 'axios'
import download from 'downloadjs'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { EspecificacionIgvTipo1 } from '@/shared/utils'
import { EspecificacionIgvTipo2 } from '@/shared/utils'
import { UnidadMedida } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import { FormaPago } from '@/shared/utils'
export default {
    name: 'NotaDebitoFacturaEmision',
    components: {
        Datepicker,
        cSwitch
    },
    data: () => {
        return {
            verDirecciones: false,
            direcciones: [],
            checkprecioventaunitario: false,
            nodescription: false,
            noProductCode: false,
            noBarCodeSunat: false,
            listades: true,
            cargandoCodBarras: false,
            cargandoBarrasSunat: false,
            cargandoDescription: false,
            checkvalorunitario: false,
            descuento: true,
            ventaGratuita: false,
            servicio: false,
            vbarras: false,
            setUpdateItem: false,
            servicio: false,
            striped: true,
            small: true,
            outlined: true,
            tipoguialock: false,
            checkdescripcionND: false,
            cargandoreceptorND: false,
            cargandoemision: false,
            descuentoGlobalMonto: '',
            setIndex: -1,
            descuentoGlobalPorcentaje: '',
            formaPago: FormaPago,
            seriedeguia: '',
            numerodeguia: '',
            tipodeguia: '09',
            fvencimiento: '',
            ordenCompra: '',
            formadepago: '000',
            descuentoItemMonto: '',
            descuentoItemPorcentaje: '',
            descripcion: '',
            valorUnitario: '',
            precioVentaUnitario: '',
            codigoSunatBarras: '',
            items: [],
            guiasRelacionada: [],
            tiposGuia: [
                {
                codigo: '09',
                nombre: 'Guia Remision Remitente'
                },
                {
                codigo: '31',
                nombre: 'Guia Remision Transportista'
                }
            ],
            items_guias: [],
            fields_guias: [
                {key: 'serie', label: 'Serie', sorteble: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'tipodeguiadescripcion', label: 'Tipo', sortable: true},
                {key: 'acciones', label: 'Acciones', sortable: true}
            ],
            items_fields: [
                {key: 'index', label: 'Item'},
                {key: 'cantidad', label: 'Cantidad', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                {key: 'valorUnitarioVista', label: 'Valor Unitario', sorteable: true},
                {key: 'descuento', label: 'Descuento', sorteable: true},
                {key: 'montoAfectacionIgv', label: 'Igv', sorteable: true},
                {key: 'valorVentaVista', label: 'Valor Total', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true},
            ],
            key: '',
            value: '',
            listaReceptores: [],
            listaProductCode: [],
            listaBarCodeSunat: [],
            listaDescription: [],
            placeholdercodigo: 'C. Sunat',
            codigoProducto: '',
            cantidad: 1,
            checkcantidad: false,
            unidadMedidaCantidad: 'NIU',
            unidades: UnidadMedida,
            listarec: '',
            tipoOperacion: '0101',
            otrosCargos: 0,
            items_adicionales: [],
            fields_adicionales: [
                {key: 'key', label: 'Clave', sortable: true},
                {key: 'value', label: 'Valor', sortable: true},
                {key: 'acciones', label: 'Acciones', sortable: true},
            ],
            receptor: {
                numero:'',
                tipo:'6',
                razonSocial:'',
                direccion:''
            },
            show: true,
            monedaDisabled: false,
            tipodemoneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            tipoMoneda: TipoMoneda,
            switchitems: false,
            labelTxt: {
                dataOn: 'Si',
                dataOff: 'No'
            },
            disabledTipoNC: false,
            state: '',
            descripcionND: '',
            tipodoc: '5',
            indexSerie: 0,
            seriesCargadas: true,
            newSerie: true,
            rolSeries: '',
            listaSeries: [],
            indexAfectados: [],
            vunitario: false,
            emitiendo: false,
            tabIndex: 4,
            selecteditem: {},
            montoActual: '',
            montoDescuento: '',
            tipoPV: '02',
            changePrecioValor: [
                {
                    id: '01',
                    descripcion: 'Precio Unitario'
                },
                {
                    id: '02',
                    descripcion: 'Valor Unitario'
                }
            ],
            fieldsNC: [
                { key:'cantidad', label:'Cantidad'},
                { key:'descripcion', label:'Descripcion'},
                { key:'valorUnitario', label:'V. Unitario'},
                { key:'valorVenta', label:'V. Total'},
                { key:'descuento', label: 'Descuento'},
                { key:'acciones', label:'Acciones'}
            ],
            invoice: [],
            listaNotaDebito: [],
            listaNotaDebitoAfectada: [],
            descuentoItemSiguiente: false,
            generalesNC: true,
            especificacionIgv1: EspecificacionIgvTipo1,
            especificacionIgv2: EspecificacionIgvTipo2,
            modalsendnc: false,
            especificacionIgv: '01',
            afectacionIgv: '01',
            monto: '',
            igv: '',
            currentdate: '',
            es: es,
            femision: '',
            hemision: '',
            previanotacredito: false,
            previacorreo: false,
            sendcorreo: false,
            total: 0.00,
            desde: 0.00,
            hasta: 0.00,
            cargando: false,
            pactual: 1,
            limite: 10,
            orden: 'desc',
            recipients: '',
            listaafectacion: [
                {
                    id: '02',
                    descripcion: 'Inafecto'
                },
                {
                    id: '01',
                    descripcion: 'Gravado'
                },
                {
                    id: '03',
                    descripcion: 'Exonerado'
                },
            ],
            Especificacion: [],
            especificacion:{
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            debitnotes: [],
            debitnotesinvoice: [],
            debitnotes_fields: [
                {key: 'serie', label: 'Serie', sortable: true},
                {key: 'numero', label: 'Numero', sortable: true},
                {key: 'emision', label: 'Emision', sortable: true},
                {key: 'receptor', label: 'Receptor', sortable: true},
                {key: 'moneda', label: 'Total Gravado', sortable: true},
                {key: 'estado', label: 'Estado', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            note: {},
            DebitNote: {
                token: '',
                serie: '',
                horaEmision: '',
                tiponotadebito: '',
                montoTotalImpuestos: '',
                totalVentaGravada: '',
                sumatoriaIgv: '',
                importeTotal: '',
                descripcion: '',
                tipoMoneda: '',
                serieAfectado: '',
                numeroAfectado: '',
                tipoComprobanteAfectado: '01',
                adicional: {
                    extras: [],
                    tipo_igv:''
                },
                items: [],
                receptor: {
                    tipo: '6',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                }
            },
            items: [],
            tiposNotaDebito: tiposNotaDebitoF,
            serieAfectada: '',
            checkSerieAfectada: false,
            responseSerieAfectado: '',
            numeroAfectado: '',
            checkNumeroAfectado: false,
            responseNumeroAfectado: '',
            cargandoemisionCaso1: false,
            cargandoemisionCaso2: false,
            caso5Emitir: false,
            pdfobject: '',
            cargandopdf: false,
            cargandopdf2: false,
            checkserie: false,
            checknumero: false,
            diasnopermitidos: {
            ranges: []
            },
            tiponotadebito: '01', 
            montoTotalImpuestos: 0.00,
            totalVentaInafecta: 0.00,
            totalVentaExonerada: 0.00,
            totalVentaExportacion: 0.00,
            totalVentaGravada: 0.00,
            sumatoriaIgv: 0.00,
            importeTotal: 0.00,
            sumatoriaIgvGratuitas: 0.00,
            sumatoriaOtrosCargos: 0.00,
            totalVentaGratuita:0.00,
            unoDieciocho:1.18,
            ceroDieciocho:0.18,
            dieciocho:18,
            // unoUno:1.1,
            // ceroUno:0.1,
            // diez:10,
            unoUno:1.105,
            ceroUno:0.105,
            diez:10.5,
            igvGlobal:null,
            selectedDoc:0,
            optionsDoc:[
                {value:0,text:'RUC'},
                {value:1,text:'Otros'},
            ]
        }
    },
    mounted () {
        this.initIgv(),
        this.initDates(),
        this.getSeries()
    },
    watch: {
        switchitems: function () {
            if(this.switchitems){
                this.disabledTipoNC = true,
                this.monedaDisabled = false
            }else{
                this.disabledTipoNC = false,
                this.monedaDisabled = true
            }
        },
        descripcion: function () {
            if(this.descripcion.length > 500){
                this.checkdescripcion = true
                this.responsecheckdescripcion = 'Alfanumerico de maximo 500 caracteres '
            }else{
                this.checkdescripcion = false
                this.responsecheckdescripcion = ''
            }
        },
        tipoOperacion: function () {
            if(this.tipoOperacion == '1001' || this.tipoOperacion == '1002'){
                this.showAccountDetraction()
            }
        },
        monto: function () {
            this.igv = parseFloat(this.monto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(2) //1.18
        },
        afectacionIgv: function () {
           if(this.afectacionIgv == '01'){
               this.Especificacion = this.especificacionIgv1
               this.especificacion = {
                    codigo: '10',
                    descripcion: 'Operacion onerosa',
                    codigoTributo: '1000'
                }
           }else{
               this.Especificacion = this.especificacionIgv2
               this.especificacion = {
                    codigo: '30',
                    descripcion: 'Operación Onerosa',
                    codigoTributo: '9998'
                }
           }
        },
        tiponotadebito: function () {
            if(this.tiponotadebito == '01' || this.tiponotadebito == '02'){
                this.generalesNC = true
            }else{
                this.generalesNC = false
            }
        },
        servicio: function (val) {
            if(this.servicio){
                this.unidadMedidaCantidad = 'ZZ'
            }else{
                this.unidadMedidaCantidad = 'NIU'
            }
        },
        especificacionIgv: function () {
            if(!this.ventaGratuita){
                this.especificacion.codigo = '10'
                this.especificacion.descripcion = 'Operacion onerosa'
                this.especificacion.codigoTributo = '1000'
                this.calcItem()
            }else{
                this.especificacion.codigo = '21'
                this.especificacion.descripcion = 'Exonerado - Transferencia gratuita'
                this.especificacion.codigoTributo = '9996'
                this.calcItemGratuitos()
            }
        },
        ventaGratuita: function () {
            if(!this.ventaGratuita){
                this.especificacion.codigo = '10'
                this.especificacion.descripcion = 'Operacion onerosa'
                this.especificacion.codigoTributo = '1000'
            }else{
                this.especificacion.codigo = '15'
                this.especificacion.descripcion = 'Grabado - Bonificaciones'
                this.especificacion.codigoTributo = '9996'
            }
        },
        precioVentaUnitario: function () {
            if(this.precioVentaUnitario < 0){
                this.checkprecioventaunitario = true
                this.responsecheckprecioventaunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkprecioventaunitario = false
                this.responsecheckprecioventaunitario = ''
            }
            if(this.especificacionIgv=='01'){
                if(!this.vunitario){
                this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                }
            }
            else{
                this.valorUnitario = this.precioVentaUnitario
            }
        },
        valorUnitario: function () {
            if(this.valorUnitario < 0){
                this.checkvalorunitario = true
                this.responsecheckvalorunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkvalorunitario = false
                this.responsecheckvalorunitario = ''
            }
            if(this.vunitario)
            {
                if(this.especificacionIgv=='01'){
                this.precioVentaUnitario = this.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                }
                else if(this.especificacionIgv=='02') {
                this.precioVentaUnitario = this.valorUnitario
                }
            }
        },
        tipodemoneda: function () {
            this.moneda = this.tipodemoneda
        },
        servicio: function (val) {
            if(this.servicio){
                this.unidadMedidaCantidad = 'ZZ'
            }else{
                this.unidadMedidaCantidad = 'NIU'
            }
        },
        vbarras: function () {
            if(this.vbarras){
                this.placeholdercodigo = 'C. Barras'
            }else{
                this.placeholdercodigo = 'C. Sunat'
            }
        },
        especificacionIgv: function () {
            if(!this.ventaGratuita){
                this.especificacion.codigo = '10'
                this.especificacion.descripcion = 'Operacion onerosa'
                this.especificacion.codigoTributo = '1000'
                this.calcItem()
            }else{
                this.especificacion.codigo = '21'
                this.especificacion.descripcion = 'Exonerado - Transferencia gratuita'
                this.especificacion.codigoTributo = '9996'
                this.calcItemGratuitos()
            }
        },
        'receptor.numero': function () {
            if(this.receptor.numero.length < 3){
                this.initReceptor()
            }
        }
    },
    computed: {
        stateSerieGuia () {
        let expreg = new RegExp("^[A-Z0-9]{4}$")
        let numeros = new RegExp("^[0-9]$")
        let arrayserie = this.seriedeguia.split('')
        if(arrayserie[0] == 'T' || numeros.test(arrayserie[0])){
            if (this.seriedeguia.length == 0){

            } else if (!expreg.test(this.seriedeguia)) {
            return false
            } else if(this.seriedeguia.length == 4 ){
            return true
            }
        }else{
            return false
        }
        },
        invalidFeedbackSerieGuia () {
        let expreg = new RegExp("^[A-Z0-9]{4}$")
        if (this.seriedeguia.length == 0) {
            return 'Ingresa una Serie'
        } else {
            return 'Minimo 4 caracteres'
        }
        },
        validFeedbackSerieGuia () {
        return this.stateSerieGuia === true ? 'Perfecto' : ''
        },
        stateSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0){

            } else if (!expreg.test(this.serieAfectada)) {
                return false
            } else if(this.serieAfectada.length == 3 ){
                return true
            }
        },
        invalidFeedbackSerieAfectada () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serieAfectada.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedbackSerieAfectada () {
            return this.stateSerieAfectada === true ? 'Perfecto' : ''
        },
        stateOrdenCompra () {
        let expreg = new RegExp("^[A-Z0-9]{1,20}$")
        if (this.ordenCompra.length == 0){

        } else if (!expreg.test(this.ordenCompra)) {
            return false
        } else if(this.ordenCompra.length < 20 ){
            return true
        }
        },
        invalidFeedbackOrdenCompra () {
        let expreg = new RegExp("^[A-Z0-9]{1,20}$")
        if (this.ordenCompra.length == 0) {
            return 'Ingresa una Orden de Compra'
        } else {
            return 'Caracter Invalido'
        }
        },
        validFeedbackOrdenCompra () {
        return this.stateOrdenCompra === true ? 'OC Valida' : ''
        },
    },
    methods: {
        setDirection: function (value) {
            this.receptor.direccion = value.direccion,
            this.verDirecciones = false
        },
        changeDirection: function () {
            this.verDirecciones = !this.verDirecciones
        },
        getReceivers: function () {
            this.cargandoreceptorND = true
            if(this.receptor.numero.length >= 3){
            this.stateReceptorRuc(this.receptor.numero)
            if(this.rucValid){
            this.listarec = true
            this.norec = false
                axios
                .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                token: this.$store.getters.userToken,
                q: this.receptor.numero,
                tipoRec: '6'
                })
                .then(response => (
                this.listaReceptores = response.data,
                this.cargandoreceptorND = false,
                this.receivercount(this.listaReceptores.length)
                ))
                .catch(error => (
                this.listaReceptores = [],
                this.cargandoreceptorND = false,
                this.listarec = false
                ))
            }  
            }else if(this.receptor.numero.length === 0){
            this.listaReceptores = [],
            this.cargandoreceptorND = false
            }else{
            this.listaReceptores = []
            }    
        },
        stateReceptorRuc (value) {
            let expreg = new RegExp('\\s|<|>|[A-Za-z]|^[3-9]|^[0]')
            if(value.length == 0){
                // this.$snotify.error('RUC Inválido','Error');
                this.rucValid = false
            } else if (expreg.test(value)) {
                this.$snotify.error('RUC Inválido','Error');
                this.rucValid = false
            } else {        
                this.rucValid = true       
            }
        },
        receivercount: function (value){
            if(value.length === 0)
            {
            this.$snotify.warning('No se encontró al receptor, ingrese el RUC completo ó agreguelo como nuevo cliente', 'Atención')
            }
        },
        initReceptor: function () {
            this.receptor = {
                numero:'',
                tipo:'6',
                direccion:'',
                razonSocial:''
            },
            this.listaReceptores = [],
            this.cargandoreceptorNC = false
        },
        pitcherReceiver: function (value) {
            if(value === 2){
            if(this.receptor.razonSocial.length >= 3){
                setTimeout(() => this.getReceiversByRSocial(), 200);
            }else if(this.receptor.razonSocial.length <= 2){
                this.initReceptor()
            }
            }
        },
        getReceiversByRSocial: function () {
            if(this.receptor.razonSocial.length>=3){
                this.cargandoreceptorNC = true
                this.listarec = true
                this.norec = false
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/lista/razonsocial',{
                token: this.$store.getters.userToken,
                q: this.receptor.razonSocial,
            })
            .then(response => (
                this.listaReceptores = response.data.response,
                this.cargandoreceptorNC = false,
                this.receivercount(this.listaReceptores.length) 
            ))
            .catch(error => (
                this.cargandoreceptorNC = false
            ))
            }else{
            this.listaReceptores = [],
            this.cargandoreceptorNC = false
            }
        },
        setReceiver: function (item) {
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial,
            this.receptor.direccion = item.direccionReferencia,
            this.direcciones = item.direcciones,
            this.listaCorreos = item.email,
            this.listarec = false,
            this.listaReceptores = []
        },
        setReceiverDescription: function (item) {
            this.cantidad = 1,
            this.codigoProducto = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoSunatBarras = item.codigoProductoSunat,
            this.precioVentaUnitario = item.precioUnitario,
            this.unidadMedidaCantidad = item.unidadMedida
            if(item.tipoAfectacionIgv == ''){
                this.especificacionIgv = '01'
            }else{
                this.especificacionIgv = item.tipoAfectacionIgv
            }
            this.listades = false,
            this.listaDescription = []
        },
        addAdicional: function () {
            this.itemAdicional.key = this.key
            this.itemAdicional.value = this.value
            this.items_adicionales.push(this.itemAdicional)
            this.itemAdicional = {}
            this.key = ''
            this.value = ''
        },
        deleteAdicional: function (value) {
            this.items_adicionales.splice(value,1)
        },
        validateInvoice: function () {
            let tiposerie = ''
            if(this.typeInvoice == 1){
                if(this.indexSerie == 0){
                this.serie = this.listaSeries[0]
                tiposerie = this.serie
                }else{
                this.serie = this.listaSeries[this.indexSerie]
                tiposerie = this.serie
                }
            }else if(this.typeInvoice == 2){
                tiposerie = this.seriecon
            } 
            if(this.receptor.numero !='' && this.items.length > 0 && !this.seriesCargadas && this.serieAfectada != '' && this.numeroAfectado != '' && this.descripcionND != ''){
                return true
            }
            else{
                return false
            }
        },
        accumulateIgvAdd: function () {
            let val = 0.00
            let valGratuita = 0.00
            this.items.forEach(function(element) {
                if(element.codigoTributo == '9996' && element.tipoPrecioVentaUnitario == '02'){
                valGratuita += parseFloat(element.montoAfectacionIgv);
                }else{
                val += parseFloat(element.montoAfectacionIgv);
                }
            });
            this.montoTotalImpuestos = val,
            this.sumatoriaIgv = val,
            this.sumatoriaIgvGratuitas = valGratuita
            return parseFloat(val).toFixed(2)
            },
        accumulateTaxesAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = parseFloat(val).toFixed(2)
            },
        accumulateRecordedSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '10'){
                val += parseFloat(element.valorVenta);
                }
            });
            this.totalVentaGravada = val
            return parseFloat(val).toFixed(2)

            },
        accumulateExoneratedSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '20'){
                val += parseFloat(element.valorVenta);
                }
            });
            this.totalVentaExonerada = val
            return parseFloat(val).toFixed(2)
            },
        accumulateUnaffectedSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '30'){
                val += parseFloat(element.valorVenta);
                }
            });
            this.totalVentaInafecta = val
            return parseFloat(val).toFixed(2)
            },
        accumulateFreeSaleAdd: function () {
            var val = 0.00
            this.items.forEach(function(element) {
                if(element.tipoAfectacionIgv == '11' ||
                element.tipoAfectacionIgv == '12' ||
                element.tipoAfectacionIgv == '13' ||
                element.tipoAfectacionIgv == '14' ||
                element.tipoAfectacionIgv == '15' ||
                element.tipoAfectacionIgv == '16' ||
                element.tipoAfectacionIgv == '31' ||
                element.tipoAfectacionIgv == '32' ||
                element.tipoAfectacionIgv == '33' ||
                element.tipoAfectacionIgv == '34' ||
                element.tipoAfectacionIgv == '35' ||
                element.tipoAfectacionIgv == '36' ||
                element.tipoAfectacionIgv == '21'
            ){
                val += parseFloat(element.valorVenta);
            }
            });
            this.totalVentaGratuita = val
            return parseFloat(val).toFixed(2)
        },
        accumulateExportSaleAdd: function () {
            var val = 0.00;
            this.items.forEach(function(element) {
            if(element.tipoAfectacionIgv == '40'){
                val += parseFloat(element.valorVenta);
            }
            });
            this.totalVentaExportacion = val
            return parseFloat(val).toFixed(2)
        },
        accumulateTotalSaleAdd: function () {
            var val = 0.00
            if(this.totalVentaGravada != 0 || this.totalVentaInafecta != 0 || this.totalVentaExonerada != 0 || this.totalVentaExportacion != 0){
            val = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada + this.totalVentaExportacion
            }else{
            val = 0.00
            }
            this.importeTotal = val
            return parseFloat(val).toFixed(2)
        },
        montoDetraccionCalcAdd: function () {
            let val = 0.00
            this.importeTotal = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada + parseFloat(this.otrosCargos)
            this.montoDetraccion = this.importeTotal * parseFloat(this.detraccion.porcentajeDetraccion)/100
            val = this.montoDetraccion
            return val.toFixed(0)
        },
        accumulateDescuentoAdd: function () {
            var val = 0.00;
            this.items.forEach(function(element) {
            val += parseFloat(element.descuento);
            });
            this.totalDescuentosAcumulados = val
            return parseFloat(val).toFixed(2)
        },
        deleteItemCasoAddItems: function (index) {
            this.$swal({
            title: 'Eliminar Item',
            text: 'Seguro de eliminar este item ???',
            icon: 'error',
            buttons: true,
            dangerMode: true
            }).then((willDelete) => {
            if(willDelete){
                this.items.splice(index,1)
                //this.item = {}
            }else{

            }
            })
        },
        calcItem: function () {
            var parent = this;
            if(parent.especificacionIgv === '01' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv
                parent.especificacion = {
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
                }
                parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else if(parent.especificacionIgv === '01' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else if(parent.especificacionIgv === '02' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv2
                parent.especificacion = {
                codigo: '30',
                descripcion: 'Operación Onerosa',
                codigoTributo: '9998'
                }
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '02' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }
            else if(parent.especificacionIgv === '03' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv3
                parent.especificacion = {
                codigo: '20',
                descripcion: 'Operación Onerosa',
                codigoTributo: '9997'
                }
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '03' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }
        },
        calcItemGratuitos: function () {
            var parent = this;
            if(parent.especificacionIgv === '01' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv
                parent.especificacion = {
                codigo: '15',
                descripcion: 'Grabado - Bonificaciones',
                codigoTributo: '9996'
                }
                parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else if(parent.especificacionIgv === '01' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            else if(parent.especificacionIgv === '02' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv2
                parent.especificacion = {
                codigo: '31',
                descripcion: 'Retiro por Bonificación',
                codigoTributo: '9996'
                }
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '02' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }
            else if(parent.especificacionIgv === '03' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv3
                parent.especificacion = {
                codigo: "21",
                descripcion: "Transferencia gratuita",
                codigoTributo: "9996"
                }
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '03' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }
        },
        validateFields: function () {
            if(this.tipoOperacion == '0200'){
                if(this.codigoSunatBarras == ''){
                return false
                }else{
                return true
                }
            }else{
                if(this.cantidad!='' && this.descripcion!='' && this.precioVentaUnitario!==''){
                return true
                }else{
                return false
                }
            }
        },
        validateFieldsGuia: function () {
            if(this.seriedeguia!='' && this.numerodeguia!='' && this.tipodeguia!==''){
                return true
            }else{
                return false
            }
        },
        validateFieldsAdicionales: function () {
            if(this.key!='' && this.value!=''){
                return true
            }else{
                return false
            }
        },
        getReceiversDescription: function (value) {
            if(value.length>2){
            this.cargandoDescription = true
            this.listades = true
            this.nodescription = false
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                // 'name, code, codesunat, codegs1'
                // Parametro ej: Shoes -> sho
                filtro: 'name',
                p: this.descripcion
            })
            .then(response => (
                this.listaDescription = response.data.response,
                this.cargandoDescription = false,
                this.receivercountDescription(this.listaDescription.length)
            ))
            .catch(error => (
                this.$snotify.warning(error.response.data.msg, 'Atención'),
                this.cargandoDescription = false
            ))
            }
        },
        getReceiversBarCodeSunat: function (value) {
            let receiver = ''
            if(this.vbarras){
            receiver = 'codegs1'
            }else{
            receiver = 'codesunat'
            }
            if(value.length>1){
            this.cargandoBarrasSunat = true
            this.listabarcodesunat = true
            this.noBarCodeSunat = false
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                // 'name, code, codesunat, codegs1'
                // Parametro ej: Shoes -> sho
                filtro: receiver,
                p: this.codigoSunatBarras
            })
            .then(response => (
                this.listaBarCodeSunat = response.data.response,
                this.cargandoBarrasSunat = false,
                this.receivercountBarrasSunat(this.listaBarCodeSunat.length)
            ))
            .catch(error => (
                this.cargandoBarrasSunat = false
            ))
            }
        },
        setReceiverBarCodeSunat: function (item) {
            this.codigoProducto = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoSunatBarras = item.codigoProductoSunat,
            this.precioVentaUnitario = item.precioUnitario,
            this.unidadMedidaCantidad = item.unidadMedida
            if(item.tipoAfectacionIgv == ''){
                this.especificacionIgv = '01'
            }else{
                this.especificacionIgv = item.tipoAfectacionIgv
            }
            this.listabarcodesunat = false,
            this.listaBarCodeSunat = []
        },
        getReceiversProductCode: function (value) {
            if(value.length>1){
            this.cargandoCodBarras = true
            this.listaproductcode = true
            this.noProductCode = false
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'code',
                p: this.codigoProducto
            })
            .then(response => (
                this.listaProductCode = response.data.response,
                this.cargandoCodBarras = false,
                this.receivercountProduct(this.listaProductCode.length)
            ))
            .catch(error => (
                this.$snotify.error(error.response.data.response.msj, 'Error'),
                this.cargandoCodBarras = false
            ))
            }
        },
        checkTabsSeries: function () {
            if(this.tabIndex == 4){
                this.getSeries()
            }
        },
        getSeries: function () {
            this.seriesCargadas = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.tipodoc, {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data, 
                this.rolSeries = response.data.rol,
                this.seriesCargadas = false,
                this.igvGlobal = response.data.igv
                ))
            .catch(error => {})
        },
        ValidateCaso1: function () {
            if(this.serieAfectado != '' && this.numeroAfectado != '' && this.descripcionND != '' && this.precioVentaUnitario != '' && this.valorUnitario != ''){
                return true
            }else{
                return false
            }
        },
        accumulateIgv: function () {
            let val = 0.00;
                this.listaNotaDebitoAfectada.forEach(function(element) {
                    if( element.codigoTributo == "9996" && element.tipoPrecioVentaUnitario == "02"){
                        // val += parseFloat(element.montoAfectacionIgv);
                    }else{
                        val += parseFloat(element.montoAfectacionIgv);
                    }                  
                });
            this.montoTotalImpuestos = val,
            this.sumatoriaIgv = val
            return val
        },
        accumulateTaxes: function () {
            var val = 0.00;
                this.listaNotaDebitoAfectada.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = val
        },
        accumulateRecordedSale: function () {
            var val = 0.00;
                this.listaNotaDebitoAfectada.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '10'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaGravada = val
            return val
        },
        accumulateExoneratedSale: function () {
            var val = 0.00;
                this.listaNotaDebitoAfectada.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '20'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaExonerada = val
            return val
        },
        accumulateGratuitaSale: function() {
        var val = 0.0;
        this.listaNotaDebitoAfectada.forEach(function(element) {
          if (
                  element.tipoAfectacionIgv == "11" ||
                  element.tipoAfectacionIgv == "12" ||
                  element.tipoAfectacionIgv == "13" ||
                  element.tipoAfectacionIgv == "14" ||
                  element.tipoAfectacionIgv == "15" ||
                  element.tipoAfectacionIgv == "16" ||
                  element.tipoAfectacionIgv == "31" ||
                  element.tipoAfectacionIgv == "32" ||
                  element.tipoAfectacionIgv == "33" ||
                  element.tipoAfectacionIgv == "34" ||
                  element.tipoAfectacionIgv == "35" ||
                  element.tipoAfectacionIgv == "36" ||
                  element.tipoAfectacionIgv == "21"
          ) {
            val += parseFloat(element.valorVenta);
          }
        });
        this.totalVentaGratuita = parseFloat(val);
        return parseFloat(val.toFixed(2));
      },
        accumulateExportacionVista: function () {
            var val = 0.00;
                this.listaNotaDebitoAfectada.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '40'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaExportacionVista = val
            return val.toFixed(2)
        },
        accumulateUnaffectedSale: function () {
            var val = 0.00;
                this.listaNotaDebitoAfectada.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '30'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaInafecta = val
            return val
        },
        accumulateTotalSale: function () {
            var val = 0.00
            this.sumatoriaOtrosCargos = parseFloat(this.invoice.sumatoriaOtrosCargos)
            if(this.totalVentaGravada != 0 || this.totalVentaInafecta != 0 || this.totalVentaExonerada != 0 || this.totalVentaExportacionVista != 0){
                val = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada + this.totalVentaExportacionVista
            }else{
                val = 0.00
            }
            this.sumatoriaOtrosCargos>0 ? val = val + this.sumatoriaOtrosCargos: val = val
            this.importeTotal = val
            return parseFloat(val)
        },
        deleteItem: function (selected, value) {
            let item = {}
            item = selected
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    if(this.tiponotadebito == '02'){
                        item.valorUnitario = selected.oldValorUnitario
                        item.porcentajeDescuento = selected.oldPorcentajeDescuento
                        item.valorVenta = selected.oldValorVenta
                        item.baseAfectacionIgv = selected.oldBaseAfectacionIgv 
                        item.montoAfectacionIgv = selected.oldMontoAfectacionIgv
                        this.listaNotaDebito.push(item)
                        this.listaNotaDebitoAfectada.splice(value,1)
                    }else if(this.tiponotadebito == '07'){
                        item.cantidad = selected.oldCantidad
                        item.valorVenta = selected.oldValorVenta
                        item.baseAfectacionIgv = selected.oldBaseAfectacionIgv 
                        item.montoAfectacionIgv = selected.oldMontoAfectacionIgv
                        this.listaNotaDebito.push(item)
                        this.listaNotaDebitoAfectada.splice(value,1)
                    }
                }else
                {

                }
            })
        },
        setUnitValue: function () {
            let nuevoitem = this.itemAlterado
            nuevoitem.valorUnitario = this.montoDescuento / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            nuevoitem.valorVenta = nuevoitem.valorUnitario * nuevoitem.cantidad
            if(this.itemAlterado.adicional == null){
                delete nuevoitem.adicional
            }else{
            }
            this.listaNotaDebitoAfectada.push(nuevoitem)
        },
        initNDDefault: function () {
            this.generalesNC = true
            this.tiponotadebito = '01'
        },
        initIgv: function () {
            if(this.especificacionIgv === '01'){
                this.Especificacion = this.especificacionIgv1
            }
            else if(this.especificacionIgv === '02'){
                this.Especificacion = this.especificacionIgv2
            }
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(4,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },
        validateDebitNote: function () {
            if(this.descripcionND != '' && this.tiponotadebito != '0' && !this.seriesCargadas){
                return true
            }
            else{
                return false
            }
        },
        listDebitNote: function () {
            this.cargando = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/factura', {
                token: this.$store.getters.userToken,
                page: this.pactual,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.debitnotes = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false
                ))
            .catch(error => {})
        },
        searchInvoice: function () {
            if(this.tiponotadebito == '01'){
                this.cargandoemisionCaso1 = true
            }else if(this.tiponotadebito == '02'){
                this.cargandoemisionCaso2 = true
            }
            axios
           .post(process.env.VUE_APP_API_URL + 'facturas/obtener/detalles',{
               token: this.$store.getters.userToken,
               p: 'F' + this.serieAfectada + '-' + this.numeroAfectado,
               filtro: 'name'
           }, config)
           .then(response => (
               this.validarBaja(response.data)
           ))
           .catch(error => (
               this.cargandoemisionCaso1 = false,
               this.cargandoemisionCaso1 = false
           ))
        },
        validarBaja: function (data) {
            this.cargandoemisionCaso1 = false,
            this.cargandoemisionCaso1 = false
            if(data.response.baja != 1){
                this.invoice = data.response,
                this.redirectDebitNoteTipo(data)
            }else if(data.response.baja === 1){
                this.$snotify.error('No se puede emitir una Nota de Débito a una factura dada de baja!','Error')
            }
        },
        redirectDebitNoteTipo: function (value) {
            if(value.success == 1){
                this.listaNotaDebito = value.response.details
                if(this.tiponotadebito == '01'){
                    this.cargandoemisionCaso1 = true,
                    this.addItemTipo1()
                }else if(this.tiponotadebito == '02'){
                    this.cargandoemisionCaso2 = false,
                    this.descuentoItemSiguiente = true
                }
                this.generalesNC = true
                this.alertaSerie()
                this.setMoneda()
            }else{
                this.$snotify.error('La Factura a la que quieres afectar no existe', 'Error'),
                this.initNDDefault(),
                this.descuentoItemSiguiente = false
            }
        },
        alertaSerie: function () {
            if(this.listaSeries.length == 0){
                this.$snotify.warning('Verifique que tenga una serie valida!', 'Cuidado')
            }
        },
        setMoneda: function () {
            var parent = this;
            let codigoMoneda = parent.invoice.tipoMoneda
            parent.tipoMoneda.forEach(function(element) {
                if(element.codigo === codigoMoneda){
                    parent.moneda.id = element.id,
                    parent.moneda.codigo = element.codigo,
                    parent.moneda.descripcion = element.descripcion,
                    parent.moneda.simbolo = element.simbolo
                }
            });
        },
        setNote: function (data) {
            this.note = data
        },
        enter: function () {
            if(this.validateFields()){
                this.addItem()
            }
        },
        sendMail: function (data) {
            this.modalsendnc = true
            this.previacorreo = true
            this.sendcorreo = true
            axios
            .post(process.env.VUE_APP_API_URL + 'notacredito/mail', {
                token: this.$store.getters.userToken,
                id: data.idNotaCredito,
                mail: this.recipients
            })
            .then(response => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.success(response.data.msg, 'Exito')
                ))
            .catch(error => (
                this.previacorreo = false,
                this.sendcorreo = false,
                this.modalsendnc = false,
                this.$snotify.error(error.response.data.response, 'Error')
            ))
        },
        viewPdf: function (data) {
            this.pdfobject = ''
            this.cargandopdf2 = true
            axios
           .post(process.env.VUE_APP_API_URL + 'notacredito/pdf',{
               token: this.$store.getters.userToken,
               id: data.idNotaCredito
           }, config)
           .then(response => (
               this.pdfobject = response.data.base64,
               this.cargandopdf2 = false
           ))
           .catch(function (error){

           })
        },
        addItemTipo1: function () {
            // this.listaNotaDebitoAfectada = []
            // this.items = []
            // let item = {
            //     unidadMedidaCantidad: '',
            //     cantidad: '',
            //     valorVenta: '',
            //     precioVentaUnitario: '',
            //     tipoPrecioVentaUnitario: '',
            //     montoTotalImpuestosItem: '',
            //     baseAfectacionIgv: '',
            //     montoAfectacionIgv: '',
            //     porcentajeImpuesto: '',
            //     tipoAfectacionIgv: '',
            //     codigoTributo: '',
            //     descripcion: '',
            //     valorUnitario: '',
            //     codigoProducto: '',
            //     codigoProductoSunat: ''
            // }
            // let nroitems = this.invoice.details.length
            // for (let i = 0; i < nroitems; i++){
            //     item.unidadMedidaCantidad = this.invoice.details[i].unidadMedidaCantidad,
            //     item.cantidad = parseFloat(this.invoice.details[i].cantidad),
            //     item.valorVenta = parseFloat(this.invoice.details[i].valorVenta),
            //     item.precioVentaUnitario = parseFloat(this.invoice.details[i].precioVentaUnitario),
            //     item.tipoPrecioVentaUnitario = this.invoice.details[i].tipoPrecioVentaUnitario,
            //     item.montoTotalImpuestosItem = this.invoice.details[i].montoTotalImpuestosItem,
            //     item.baseAfectacionIgv = parseFloat(this.invoice.details[i].baseAfectacionIgv),
            //     item.montoAfectacionIgv = parseFloat(this.invoice.details[i].montoAfectacionIgv),
            //     item.porcentajeImpuesto = parseFloat(this.invoice.details[i].porcentajeImpuesto),
            //     item.tipoAfectacionIgv = this.invoice.details[i].tipoAfectacionIgv,
            //     item.codigoTributo = this.invoice.details[i].codigoTributo,
            //     item.descripcion = this.invoice.details[i].descripcion,
            //     item.valorUnitario = parseFloat(this.invoice.details[i].valorUnitario),
            //     item.codigoProducto = this.invoice.details[i].codigoProducto,
            //     item.codigoProductoSunat = this.invoice.details[i].codigoProductoSunat,
            //     this.listaNotaDebitoAfectada.push(item)
            //     item = {
            //         unidadMedidaCantidad: '',
            //         cantidad: '',
            //         valorVenta: '',
            //         precioVentaUnitario: '',
            //         tipoPrecioVentaUnitario: '',
            //         montoTotalImpuestosItem: '',
            //         baseAfectacionIgv: '',
            //         montoAfectacionIgv: '',
            //         porcentajeImpuesto: '',
            //         tipoAfectacionIgv: '',
            //         codigoTributo: '',
            //         descripcion: '',
            //         valorUnitario: '',
            //         codigoProducto: '',
            //         codigoProductoSunat: ''
            //     }
            // }
            // this.sendNoteDebit()  



            this.listaNotaDebitoAfectada = []
            let item = {}
            item.unidadMedidaCantidad = 'NIU'
            item.cantidad = 1
            item.precioVentaUnitario = this.precioVentaUnitario
            item.montoTotalImpuestosItem = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            item.baseAfectacionIgv = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            // item.montoAfectacionIgv = this.precioVentaUnitario - (this.precioVentaUnitario/1.18)
            item.tipoAfectacionIgv = this.especificacion.codigo
            item.descripcion = this.descripcionND
            item.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            if(this.especificacion.codigo == '10' || this.especificacion.codigo == '20' || this.especificacion.codigo == '30'){
                item.tipoPrecioVentaUnitario = '01'
            }
            else{
                item.tipoPrecioVentaUnitario = '02'
            }
            if(this.ventaGratuita){
                item.valorUnitario = (0.00).toFixed(10)
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
            }else{
                item.valorUnitario = parseFloat(this.valorUnitario).toFixed(10)
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
            }
            if(item.tipoAfectacionIgv == '20' || item.tipoAfectacionIgv == '30'){
                item.valorVenta = this.precioVentaUnitario
                item.porcentajeImpuesto = parseFloat(0.00)
            }else{
                item.valorVenta = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
            }
            if(this.especificacionIgv == '01'){
                item.montoAfectacionIgv = (item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105)).toFixed(10) //0.18
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
                item.codigoTributo = '1000'
            }else if(this.especificacionIgv == '02'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
                item.baseAfectacionIgv = parseFloat((item.valorUnitario) * (item.cantidad))
                item.codigoTributo = '9998'
            }else if(this.especificacionIgv == '03'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
                item.baseAfectacionIgv = parseFloat((item.valorUnitario) * (item.cantidad))
                item.codigoTributo = '9997'
            }
            this.listaNotaDebitoAfectada.push(item)
            this.sendNoteDebit()
            return true
        },
        addItem: function () {
            let item ={
                baseAfectacionIgv: '',
                adicional: {
                    descuentoItem: {}
                }
            }
                item.valorVentaSinAfectar = this.valorUnitario*this.cantidad
                item.tipoAfectacionIgv = this.especificacion.codigo
            if(this.tipoOperacion == '0200'){
                item.codigoTributo = '9995',
                item.tipoAfectacionIgv = '40'
            }else{
                item.codigoTributo = this.especificacion.codigoTributo
            }
            if(this.codigoProducto != ''){
                item.codigoProducto = this.codigoProducto
            }
            if(!this.vbarras){
                item.codigoProductoSunat = this.codigoSunatBarras
            }else{
                item.codigoProductoGs1 = this.codigoSunatBarras
            }
                item.unidadMedidaCantidad = this.unidadMedidaCantidad
                item.cantidad = parseFloat(this.cantidad)
                item.descripcion = this.descripcion
                item.valorUnitario = parseFloat(this.valorUnitario).toFixed(10)
            if(this.especificacion.codigo == '10' || this.especificacion.codigo == '20' || this.especificacion.codigo == '30'){
                item.tipoPrecioVentaUnitario = '01'
            }
            else{
                item.tipoPrecioVentaUnitario = '02'
            }
            if(this.descuentoItemMonto != ''){
                item.descuento = parseFloat(this.descuentoItemMonto).toFixed(10)
                item.porcentajeDescuento = parseFloat(this.descuentoItemMonto) / item.valorVentaSinAfectar
            }else if(this.descuentoItemPorcentaje != ''){
                item.descuento = ((this.descuentoItemPorcentaje)/100 * item.valorUnitario * item.cantidad).toFixed(10)
                item.porcentajeDescuento =this.descuentoItemPorcentaje / 100
            }else{
                item.descuento = (0.00).toFixed(10)
                delete item.adicional.descuentoItem
            }
            if(item.descuento == 0){
                item.baseAfectacionIgv = item.valorUnitario*item.cantidad
            }else{
                item.baseAfectacionIgv = item.valorUnitario*item.cantidad-item.descuento
            }
            // Bloque de las gratuitas
            if(this.ventaGratuita){
                item.valorUnitario = (0.00).toFixed(10)
                item.valorUnitarioVista = parseFloat(this.valorUnitario).toFixed(10)
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
                item.valorVentaVista = (0.00).toFixed(10)
            }else{
                item.valorUnitario = parseFloat(this.valorUnitario).toFixed(10)
                item.valorUnitarioVista = item.valorUnitario
                item.valorVenta = item.baseAfectacionIgv.toFixed(10)
                item.valorVentaVista = item.valorVenta
            }
            if(item.tipoAfectacionIgv == '20' || item.tipoAfectacionIgv == '30'){
                item.porcentajeImpuesto = parseFloat(0.00)
            }else{
                item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
            }
            if(this.especificacionIgv == '01'){
                item.montoAfectacionIgv = (item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105)).toFixed(10) //0.18
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }else if(this.especificacionIgv == '02'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }else if(this.especificacionIgv == '03'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }
            if(this.tipoOperacion == '0200'){
                item.montoAfectacionIgv = (0.00).toFixed(10)
                item.montoTotalImpuestosItem = item.montoAfectacionIgv
            }
                item.precioVentaUnitario = this.precioVentaUnitario
            if(item.descuento != 0){
                item.adicional.descuentoItem.codigoMotivoDescuento = '01',
                item.adicional.descuentoItem.factorNumericoDescuento = parseFloat(item.porcentajeDescuento).toFixed(5)
                item.adicional.descuentoItem.montoDescuento = parseFloat(item.descuento).toFixed(2)
                item.adicional.descuentoItem.montoBaseDescuento = parseFloat(item.valorVentaSinAfectar).toFixed(2)
            }else{
                delete item.adicional.descuentoItem
            }
            if(this.setIndex != -1){
                Object.assign(this.items[this.setIndex], item)
                this.$snotify.warning('Item Actualizado Correctamente', 'Atencion'),
                this.setIndex = -1
                this.setUpdateItem = false
            }else{
                this.items.push(item)
            }
                this.cantidad = 1,
                this.codigoProducto = '',
                this.codigoTributo = '',
                this.tipoAfectacionIgv = '',
                this.descripcion = '',
                this.precioVentaUnitario = '',
                this.valorUnitario = '',
                this.codigoSunatBarras = '',
                this.descuentoItemMonto = '',
                this.descuentoItemPorcentaje = '',
                this.descuento = true,
                this.unidadMedidaCantidad = 'NIU',
                this.ventaGratuita = false
                item = {
                baseAfectacionIgv: '',
                adicional: {
                    descuentoItem: {}
                }
            }
        },
        updateItem: function (index, itemUpdate) {
            let itemChange = itemUpdate
            let item = {}
            this.setUpdateItem = true
            this.setIndex = index
            this.cantidad = itemChange.cantidad
            this.unidadMedidaCantidad = itemChange.unidadMedidaCantidad
            this.codigoProducto = itemChange.codigoProducto
            this.codigoSunatBarras = itemChange.codigoSunatBarras
            this.descripcion = itemChange.descripcion
            this.precioVentaUnitario = itemChange.precioVentaUnitario
            this.valorUnitario = itemChange.valorUnitario
        },
        setrowCaso2: function (value, i) {     
            let selected = {
                    adicional: value.adicional,
                    baseAfectacionIgv: value.baseAfectacionIgv,
                    cantidad: value.cantidad,
                    codigoProducto: value.codigoProducto,
                    codigoProductoGs1: value.codigoProductoGs1,
                    codigoProductoSunat: value.codigoProductoSunat,
                    codigoTributo: value.codigoTributo,
                    descripcion: value.descripcion,
                    aumento: value.aumento,
                    cambiarDescripcion: value.cambiarDescripcion,
                    descontarCantidad: value.descontarCantidad,
                    idFactura: value.idFactura,
                    idFacturaItem: value.idFacturaItem,
                    montoAfectacionIgv: value.montoAfectacionIgv,
                    montoTotalImpuestosItem: value.montoTotalImpuestosItem,
                    porcentajeAumento: value.porcentajeAumento,
                    porcentajeImpuesto: value.porcentajeImpuesto,
                    // precioVentaUnitario: value.precioVentaUnitario,
                    precioVentaUnitario: value.aumento,
                    tipoAfectacionIgv: value.tipoAfectacionIgv,
                    tipoPrecioVentaUnitario: value.tipoPrecioVentaUnitario,
                    unidadMedidaCantidad: value.unidadMedidaCantidad,
                    valorUnitario: value.valorUnitario,
                    valorVenta: value.valorVenta
                }
                if(this.tiponotadebito == '02'){
                        if(selected.adicional == null || selected.adicional == '[]'){
                            delete selected.adicional
                        }else{
                            selected.adicional = JSON.parse(value.adicional)
                        }
                        // valores anteriores
                        selected.oldValorUnitario = selected.valorUnitario
                        selected.oldPorcentajeAumento = selected.porcentajeAumento
                        selected.oldValorVenta = selected.valorVenta
                        selected.oldBaseAfectacionIgv = selected.baseAfectacionIgv
                        selected.oldMontoAfectacionIgv = selected.montoAfectacionIgv
                        // valores cambiados
                        if(selected.tipoAfectacionIgv == '11'  || 
                            selected.tipoAfectacionIgv == '12' ||
                            selected.tipoAfectacionIgv == '13' ||
                            selected.tipoAfectacionIgv == '14' ||
                            selected.tipoAfectacionIgv == '15' ||
                            selected.tipoAfectacionIgv == '16' ||
                            selected.tipoAfectacionIgv == '31' ||
                            selected.tipoAfectacionIgv == '32' ||
                            selected.tipoAfectacionIgv == '33' ||
                            selected.tipoAfectacionIgv == '34' ||
                            selected.tipoAfectacionIgv == '35' ||
                            selected.tipoAfectacionIgv == '36' ||
                            selected.tipoAfectacionIgv == '21'){

                            selected.valorUnitario = parseFloat(0.0);
                            selected.valorVenta = parseFloat(selected.precioVentaUnitario * selected.cantidad)
                            selected.baseAfectacionIgv = parseFloat(selected.precioVentaUnitario * selected.cantidad)
                            if(selected.codigoTributo == '9996' && selected.tipoAfectacionIgv == '15'){
                                selected.montoAfectacionIgv =  parseFloat(((selected.baseAfectacionIgv) * ((this.$store.state.igv == 18 ? 0.18 : 0.105))).toFixed(2)) //0.18
                            }else{
                                selected.montoAfectacionIgv =  0
                            }
                            selected.montoTotalImpuestosItem = parseFloat(0.0)
                            selected.porcentajeAumento = (selected.valorUnitario * 100) / value.valorUnitario
                            }else if(selected.tipoAfectacionIgv == '40'){ //Nota Debito Exportacion
                            selected.valorUnitario = selected.precioVentaUnitario
                            selected.porcentajeAumento = (selected.valorUnitario * 100) / value.valorUnitario
                            selected.valorVenta = selected.precioVentaUnitario * selected.cantidad
                            selected.baseAfectacionIgv = selected.precioVentaUnitario * selected.cantidad   
                            selected.montoAfectacionIgv = 0
                            }else{
                            selected.valorUnitario = value.aumento/(this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                            selected.porcentajeAumento = (selected.valorUnitario * 100) / value.valorUnitario
                            selected.valorVenta = selected.valorUnitario * selected.cantidad
                            selected.baseAfectacionIgv = selected.valorVenta
                            if(selected.montoAfectacionIgv == 0){
                                selected.montoAfectacionIgv = 0
                            }else{
                                selected.montoAfectacionIgv = selected.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                                selected.montoTotalImpuestosItem = selected.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                            }
                        }                    
                        this.listaNotaDebitoAfectada.push(selected)
                        this.listaNotaDebito.splice(i,1)
                        this.caso5Emitir = true
                }
        },
        sendNoteDebit: function () {
            this.emitiendo = true
            this.DebitNote.token = this.$store.getters.userToken
            if(this.femision != ''){
                this.DebitNote.fechaEmision = this.femision
            }
            if(this.indexSerie == 0){
                this.DebitNote.serie = this.listaSeries[0]
            }else{
                this.DebitNote.serie = this.listaSeries[this.indexSerie]
            }
            this.DebitNote.adicional.tipo_igv = this.igvGlobal
            this.DebitNote.tipoNotaDebito = this.tiponotadebito
            this.DebitNote.descripcion = this.descripcionND
            this.DebitNote.tipoMoneda = this.invoice.tipoMoneda
            this.DebitNote.serieAfectado = 'F' + this.serieAfectada
            this.DebitNote.numeroAfectado = this.numeroAfectado
            this.DebitNote.receptor.nro = this.invoice.idReceptor
            this.DebitNote.sumatoriaIgv = this.accumulateIgv()
            this.DebitNote.montoTotalImpuestos = this.accumulateIgv()
            this.DebitNote.totalVentaGravada = this.accumulateRecordedSale()
            this.DebitNote.totalVentaExonerada = this.accumulateExoneratedSale()
            this.DebitNote.totalVentaInafecta = this.accumulateUnaffectedSale()
            this.DebitNote.totalVentaGratuita = this.accumulateGratuitaSale()
            this.DebitNote.totalVentaExportacion = this.accumulateExportacionVista()
            this.DebitNote.importeTotal = this.accumulateTotalSale()    
            if(this.sumatoriaOtrosCargos > 0){
                this.DebitNote.sumatoriaOtrosCargos = this.sumatoriaOtrosCargos
            }
            this.DebitNote.items = this.listaNotaDebitoAfectada
            axios
           .post(process.env.VUE_APP_API_URL + 'notadebito/emitir', this.DebitNote, config)
           .then(response => (
               this.cargandoemisionCaso1 = false,
               this.cargandoemisionCaso2 = false,
               this.cargandoemision = false,
               this.descuentoItemSiguiente = false,
               this.$snotify.success(response.data.msg, 'Exito'),
               this.initNDebito()
           ))
           .catch(error => (
                this.cargandoemisionCaso1 = false,
                this.cargandoemisionCaso2 = false,
                this.cargandoemision = false,
                this.emitiendo = false,
                this.descuentoItemSiguiente = false
                // this.$snotify.error(error.response.data.response.message, 'Error')
            ))
        },
        initNDebito: function (){
            this.items = [],
               this.listaNotaDebito = [],
               this.listaNotaDebitoAfectada = [],
               this.serieAfectada = '',
               this.numeroAfectado = '',
               this.descripcionND = '',
               this.monto = '',
               this.igv = '',
               this.tiponotadebito == '01',
               this.changeTab(5),
               this.tabIndex = 5,
               this.emitiendo = false,
               this.$snotify.success(response.data.msg, 'Exito'),
               this.initNDDefault(),
               this.descuentoItemSiguiente = false,
               this.DebitNote = {
                   token: '',
                    serie: '',
                    horaEmision: '',
                    tiponotadebito: '',
                    montoTotalImpuestos: '',
                    totalVentaGravada: '',
                    sumatoriaIgv: '',
                    importeTotal: '',
                    descripcion: '',
                    tipoMoneda: '',
                    serieAfectado: '',
                    numeroAfectado: '',
                    tipoComprobanteAfectado: '01',
                    items: [],
                    receptor: {
                        tipo: '6',
                        nro: ''
                    }
               }
        },
        sendNCAddItems: function () {
            this.cargandoemision = true
            this.DebitNote.token = this.$store.getters.userToken
            if(this.indexSerie == 0){
                this.DebitNote.serie = this.listaSeries[0]
            }else{
                this.DebitNote.serie = this.listaSeries[this.indexSerie]
            }
            this.DebitNote.receptor.tipo = '6',
            this.DebitNote.receptor.nro = this.receptor.numero.toString()
            this.DebitNote.receptor.razonSocial = this.receptor.razonSocial
            this.DebitNote.receptor.direccionFiscal = this.receptor.direccionFiscal
            this.DebitNote.tipoNotaDebito = this.tiponotadebito
            this.DebitNote.serieAfectado = this.serieAfectada
            this.DebitNote.numeroAfectado = this.numeroAfectado
            this.DebitNote.descripcion = this.descripcionND
            this.DebitNote.tipoMoneda = this.invoice.tipoMoneda
            this.DebitNote.montoTotalImpuestos = this.invoice.montoTotalImpuestos
            this.DebitNote.totalVentaGravada = this.invoice.totalVentaGravada
            this.DebitNote.sumatoriaIgv = this.invoice.sumatoriaIgv
            this.DebitNote.importeTotal = this.invoice.importeTotal

            if(this.totalVentaGratuita > 0 && this.totalVentaGravada > 0){
            // Caso de Gratuitas combinadas con Gravadas
            this.DebitNote.montoTotalImpuestos = this.montoTotalImpuestos
            this.DebitNote.totalVentaGratuita = this.totalVentaGratuita
            this.DebitNote.sumatoriaIgvGratuitas = this.sumatoriaIgvGratuitas
            this.DebitNote.totalVentaGravada = this.totalVentaGravada
            this.DebitNote.sumatoriaIgv = this.sumatoriaIgv
            this.DebitNote.totalVentaExonerada = this.totalVentaExonerada
            this.DebitNote.totalVentaInafecta = this.totalVentaInafecta
            this.DebitNote.totalVentaExportacion = this.totalVentaExportacion
            this.DebitNote.importeTotal = this.importeTotal
            }else if(this.totalVentaGratuita > 0 && this.totalVentaGravada == 0){
            // Caso de solo gratuitas
            this.DebitNote.montoTotalImpuestos = 0.00
            this.DebitNote.totalVentaGratuita = this.totalVentaGratuita
            this.DebitNote.sumatoriaIgvGratuitas = this.sumatoriaIgvGratuitas
            this.DebitNote.importeTotal = 0.00
            }
            this.DebitNote.montoTotalImpuestos = this.montoTotalImpuestos
            this.DebitNote.sumatoriaIgv = this.sumatoriaIgv
            this.DebitNote.importeTotal = this.importeTotal
            this.DebitNote.totalVentaGravada = this.totalVentaGravada
            this.DebitNote.totalVentaExonerada = this.totalVentaExonerada
            this.DebitNote.totalVentaInafecta = this.totalVentaInafecta
            this.DebitNote.totalVentaExportacion = this.totalVentaExportacion
            if(this.guiasRelacionada.length > 0){
                this.DebitNote.guiasRelacionada = this.guiasRelacionada
            }
            if(this.items_adicionales.length > 0){
                this.DebitNote.adicional.extras = this.items_adicionales
            }
           
            this.DebitNote.tipoOperacion = this.tipoOperacion
            
            if(this.femision != ''){
            this.DebitNote.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
            }
            if(this.fvencimiento != ''){
            this.DebitNote.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
            }
            if(this.formadepago != '000'){
            this.DebitNote.adicional.formaPago = this.formadepago
            }
            if(this.ordenCompra != ''){
                this.DebitNote.adicional.ordenCompra = this.ordenCompra
            }
            this.DebitNote.items = this.items,
            this.DebitNote.tipoMoneda = this.moneda.codigo
            axios
            .post(process.env.VUE_APP_API_URL + 'notadebito/emitir', this.DebitNote)
            .then(response => (
                this.$snotify.success(response.data.msg, 'Exito'),
                this.vunitario = false,
                this.servicio = false,
                this.servicio = false,
                this.switchitems = false,
                this.descuentoItemSiguiente = false,
                this.items = [],
                this.listaNotaCredito = [],
                this.listaNotaDebitoAfectada = [],
                this.serieNC = '',
                this.serieAfectada = '',
                this.numeroAfectado = '',
                this.descripcionND = '',
                this.monto = '',
                this.igv = '',
                this.tiponotadebito == '01',
                this.emitiendo = false,
                this.receptor.numero = '',
                this.receptor.direccionReferencia = '',
                this.receptor.razonSocial = '',
                this.receptor.tipo ='6',
                this.cargandoemision = false,
                this.tipoDocumento = 0,
                this.formadepago = '000',
                this.ordenCompra = '',
                this.items_guias = [],
                this.guiasRelacionada = [],
                this.seriedeguia = '',
                this.numerodeguia = '',
                this.tipodeguia = '09',
                this.items_adicionales = [],
                this.fvencimiento = '',
                this.key = '',
                this.value = '',
                this.typeInvoice = 1,
                this.items = [],
                this.descuentoGlobalMonto = '',
                this.descuentoGlobalPorcentaje = '',
                this.descuentoItemMonto = '',
                this.descuentoItemPorcentaje = '',
                this.montoTotalImpuestos = 0.00,
                this.totalVentaInafecta = 0.00,
                this.totalVentaExonerada = 0.00,
                this.totalVentaExportacion = 0.00,
                this.totalVentaGravada = 0.00,
                this.totalVentaGratuita = 0.00,
                this.sumatoriaIgv = 0.00,
                this.importeTotal = 0.00,
                this.ventaGratuita = false,
                this.tipodemoneda = {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                
                this.DebitNote = {
                    token: '',
                    serie: '',
                    horaEmision: '',
                    descripcion: '',
                    tiponotadebito: '',
                    importeTotal: 0.00,
                    montoTotalImpuestos: 0.00,
                    totalVentaInafecta: 0.00,
                    totalVentaExonerada: 0.00,
                    totalVentaExportacion: 0.00,
                    totalVentaGravada: 0.00,
                    totalVentaGratuita: 0.00,
                    sumatoriaIgv: 0.00,
                    descripcion: '',
                    tipoMoneda: '',
                    serieAfectado: '',
                    numeroAfectado: '',
                    tipoComprobanteAfectado: '01',
                    items: [],
                    receptor: {
                        tipo: '6',
                        nro: ''
                    }
                },
                this.changeTab(5),
                this.tabIndex = 5,
                this.initNDDefault()
            ))
            .catch(error => (
            this.cargandoemision = false,
            this.vunitario = false,
            this.servicio = false,
            this.servicio = false,
            this.tiponotacredito == '01',
            this.emitiendo = false,
            this.changeTab(5),
            this.tabIndex = 5,
            this.$snotify.error(error.response.data.response.description, 'Error'),
            this.initNDDefault()
            ))
        },
         customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        }
    }
}
</script>

<style>
    .cabecera {
        margin-top: 15px;
    }
    .espacio {
        margin-left: 15px;
    }
    .messagetiponotadebito {
        color: #8d8d8d;
        font-size: 11px;
    }
    .input-requerido {
        color:red;
        opacity: 0.7;
    }
    .descuento {
        background-color: #ccffff;
    }
    .alineacionTotales{
        margin-right: 50%;
        text-align: right;
    }
</style>
